export default __webpack_public_path__ + "media/images/Design-Sombre-e7a281853e0d210595c7abeba1c514c0.jpg";